import { Badge, Box, Group, Stack, Text, Tooltip } from '@mantine/core';
import {
    MODEM_HEALTH_STATUSES,
    SIM_CARD_STATUSES,
} from '../../../../common/enums/enums';
import { getEnumColor, getEnumLabel } from '../../../../../utils/enumUtils';

const StatusCell = ({ cell }) => {
    const { column, row } = cell;
    const rowData = row.original;

    const simcardStatus = rowData.simcard?.status || 'None';
    const modemStatus = rowData.state?.healthStatus || 'None';

    const simcardStatusLabel = getEnumLabel(SIM_CARD_STATUSES, simcardStatus);
    const simcardColor = getEnumColor(SIM_CARD_STATUSES, simcardStatus);

    const modemStatusLabel = getEnumLabel(MODEM_HEALTH_STATUSES, modemStatus);
    const modemStatusColor = getEnumColor(MODEM_HEALTH_STATUSES, modemStatus);

    return (
        <Stack
            gap={2}
            align={'center'}>
            <Tooltip label={'SIM Status'}>
                <Badge
                    color={simcardColor}
                    size={'xs'}>
                    {simcardStatusLabel}
                </Badge>
            </Tooltip>
            <Tooltip label={'Modem Status'}>
                <Badge
                    color={modemStatusColor}
                    size={'xs'}>
                    {modemStatusLabel}
                </Badge>
            </Tooltip>
        </Stack>
    );
};

const StatusColumn = () => ({
    accessorKey: 'status',
    header: 'Status',
    size: 2,
    minSize: 60,
    Cell: ({ cell }) => <StatusCell cell={cell} />,
});
export default StatusColumn;
